export default __webpack_public_path__ + "static/media/login.0cd3e3a6.svg";